import { Controller } from "@hotwired/stimulus"

// One native input supplies the cart amount. Presets only edit that input,
// so a stale custom value can never override a later preset selection.
export default class extends Controller {
  static targets = ["input", "presets", "preset", "customPanel", "label"]
  static values = { product: String, cta: String, fallbackCta: String }

  connect() {
    this.presetsTarget.hidden = false
    this.render()
  }

  select(event) {
    if (event.target.value === "__custom") {
      this.chooseCustom()
    } else {
      this.inputTarget.value = event.target.value
      this.render()
      this.publish()
    }
  }

  chooseCustom() {
    this.customPanelTarget.hidden = false
    this.presetTargets.forEach((radio) => { radio.checked = radio.value === "__custom" })
    this.inputTarget.focus({ preventScroll: true })
    this.inputTarget.select()
  }

  update() {
    this.updateLabel()
    this.publish()
  }

  sync(event) {
    if (event.detail.productId !== this.productValue || event.target === this.element) return
    this.inputTarget.value = event.detail.amount
    this.render()
  }

  render() {
    const value = this.inputTarget.value
    const preset = this.presetTargets.find((radio) => radio.value === value)
    this.presetTargets.forEach((radio) => { radio.checked = radio === preset || (!preset && radio.value === "__custom") })
    this.customPanelTarget.hidden = !!preset && this.inputTarget.validity.valid
    this.updateLabel()
  }

  updateLabel() {
    const label = this.inputTarget.validity.valid
      ? this.ctaValue.replace("__AMOUNT__", this.inputTarget.value)
      : this.fallbackCtaValue
    this.labelTargets.forEach((target) => { target.textContent = label })
  }

  publish() {
    if (!this.inputTarget.validity.valid) return
    this.element.dispatchEvent(new CustomEvent("atento:amount-changed", {
      bubbles: true,
      detail: { productId: this.productValue, amount: this.inputTarget.value }
    }))
  }
}
